document.addEventListener('DOMContentLoaded', () => {
    // Select elements with the base class
    const animatedElements = document.querySelectorAll('.animate-on-scroll');

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    // Get all classes on the element
                    const elementClasses = entry.target.classList;

                    // Find the animation class (starting with "animate-" but not the base class)
                    for (const className of elementClasses) {
                        if (className.startsWith('animate-') && className !== 'animate-on-scroll') {
                            // The element already has the animation class, but it's not playing
                            // We just need to make it "active" by removing and re-adding it
                            entry.target.classList.remove(className);
                            // Force a reflow to restart the animation
                            void entry.target.offsetWidth;
                            // Add the class back
                            entry.target.classList.add(className);
                        }
                    }

                    observer.unobserve(entry.target); // Stop observing after animation
                }
            });
        },
        {
            threshold: 0.1, // Trigger when 10% of the element is visible
        }
    );

    // Observe each animated element
    animatedElements.forEach((element) => {
        observer.observe(element);
    });
});